<template>
    <v-dialog v-model="dialog" max-width="70vw" @click:outside="closeModal()">
        <v-card>
            <v-card-title class="headline"><strong>Vui lòng xác nhận thông tin (Chú ý thời hạn, Sản phẩm, Giá tiền...)</strong></v-card-title>

            <div v-if="!_.isEmpty(dataDialog)">
                <v-row>
                    <v-col cols="12" sm="12" class="order-products-wrapper" style="overflow: auto">
                        <v-simple-table class="table-layout table-small-screen">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th><b>Tên sản phẩm</b></th>
                                        <th style="width: 100px">Số lượng</th>
                                        <th>Đơn giá</th>
                                        <th><b>Thành tiền</b></th>
                                        <th style="width: 164px !important; max-width: 162px !important;"><b>Thời hạn</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(product, index) in dataDialog.products" :key="index" style="height: 30px">
                                        <td>
                                            <b>{{ product.name }}</b>
                                        </td>
                                        <td>
                                            {{product.quantity}}
                                        </td>
                                        <td>
                                            {{formatPrice(product.price)}}
                                        </td>
                                        <td>
                                            <b>{{formatPrice(product.price * product.quantity)}}<u>đ</u></b>
                                        </td>
                                        <td>
                                            <template v-if="product.activeType === 1 || product.activeType === 3">
                                                    <b v-if="product.endDate">{{ product.endDate }}</b>
                                                    <b v-else-if="product.endMonth">{{ product.endMonth }} tháng</b>
                                            </template>
                                            <template v-if="product.activeType === 2">
                                                <b><i>Tự kích hoạt</i></b>
                                                <div style="color: red; font-style: italic">
                                                    ( Thời hạn chờ kích hoạt tối đa là 1 năm )
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="3" style="padding-left: 50px">
                                            <tr>
                                                <td class="table-footer-label"><b>Tổng giá trị đơn hàng:</b></td>
                                                <td class="table-footer-value"><b>{{formatPrice(dataDialog.totalPrice)}}</b></td>
                                            </tr>
                                            <tr>
                                              <td class="table-footer-label"><b>Tổng giá trị đơn hàng (sau khi chiết khấu):</b></td>
                                              <td class="table-footer-value"><b>{{formatPrice(afterDiscount)}}</b></td>
                                            </tr>
                                            <tr>
                                                <td class="table-footer-label"><b>Hình thức thanh toán:</b></td>
                                                <td class="table-footer-value"><b>{{dataDialog.paymentType}}</b></td>
                                            </tr>
                                        </td>
                                        <td colspan="3">
                                            <tr>
                                                <td class="table-footer-label"><b>SĐT:</b></td>
                                                <td class="table-footer-value" colspan="2">{{dataDialog.shippingAddress.phone}}</td>
                                            </tr>
                                            <tr v-if="dataDialog.paymentType == 'COD'">
                                                <td class="table-footer-label"><b>Địa chỉ:</b></td>
                                                <td class="table-footer-value" colspan="3">{{dataDialog.shippingAddress.detailAddress}}, {{dataDialog.shippingAddress.xaName}} {{dataDialog.shippingAddress.huyenName}} {{dataDialog.shippingAddress.tinhName}}</td>
                                            </tr>
                                        </td>
                                    </tr>
                                </tfoot>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="success"
                    @click="orderAction()"
                    style="float: right; font-size: 14px"
                    v-if="checkEndDate"
                    :loading="loading"
                    :disabled="loading"
                >
                    Đồng ý
                </v-btn>
                <v-card-text class="text-center text-red" v-else>Ngày hết hạn sản phẩm không đúng!</v-card-text>
                <v-btn
                    color="primary"
                    text
                    @click="closeModal()"
                    style="float: right; font-size: 14px"
                >
                    Hủy bỏ
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory'
import * as moment from "moment";
const AddressRepository = RepositoryFactory.get('address')
const AgencyRepository = RepositoryFactory.get('agency')
export default {
    props: {
        loading: {
          type: Boolean,
          default: false
        },
        dialog: {
            type: Boolean,
            default: false
        },
        childCustomers: {
            type: Array,
            default: () => {[]}
        },
        courseRegisters: {
            type: Array,
            default: () => {[]}
        },
        dataDialog: {
            type: Object,
            default: () => {{}}
        },
        provinces: {
            type: Array,
            default: () => {[]}
        },
        checkEndDate: {
          type: Boolean,
          default: true
        }
    },
    methods: {
        formatDateVN(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '';
        },
        closeModal() {
            this.$emit('closeModal')
        },
        getProductName(id, type) {
            let product = this.courseRegisters.find(item => item.id == (type + '-' + id))
            if (product) {
                return product.name
            } else {
                return ''
            }
        },
        getChildName(id) {
            let child = this.childCustomers.find(item => item.id == id)
            if (child) {
                return child.fullName
            } else {
                return ''
            }
        },
        async orderAction() {
            let dataCreate = _.cloneDeep(this.dataDialog);
            const loader = this.$loading.show()
            let price = (this.dataDialog.totalPrice * Number(this.dataDialog.discount) / 100);
            let totalPrice =  Math.round(this.dataDialog.totalPrice - price)
            dataCreate.totalPrice = totalPrice;
            const response = await AgencyRepository.createNewOrder(dataCreate)
            loader.hide()
            if (response.error) {
                this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: _.get(response, 'message', '')
                });
            } else {
                this.$swal({
                    title: 'Thêm đơn hàng thành công!',
                    confirmButtonText: 'Đồng ý',
                }).then(() => {
                    window.location.href = '/agency/detail/'+ this.$route.params.id+ '?tabIndex=1'
                });
            }
        }
    },
    computed: {
      afterDiscount() {
        let price = (this.dataDialog.totalPrice * Number(this.dataDialog.discount) / 100);
        return Math.round(this.dataDialog.totalPrice - price)
      },
    }
}
</script>

<style scoped>
.table-footer-label {
    font-size: 14px;
    text-align: left;
}
.table-footer-value {
    font-size: 14px;
    text-align: left;
}
b {
    font-weight: bold;
}
.text-red {
  color: red;
}
</style>